import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private router: Router) {

   }

  flag_showLogin = false;

  ngOnInit(): void {
    // this.flag_showLogin = true;
    // this.router.navigate(['/login-aws']);
      // setTimeout(() => {
      //   this.flag_showLogin = true;
      //   this.router.navigate(['/login-aws']);

      // }, 3000);
  }

}
